// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-100, 8px)",
  margin: `0 ${"var(--ds-space-075, 6px)"}`,
  height: '40px',
  '&:hover': {
    cursor: 'pointer'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormName = styled.span({
  flexGrow: 1,
  flexShrink: 2,
  flexBasis: 0,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});